import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {IP2pDepositingItem, IP2pDepositItem, MarketAction, ModalNames} from '@dev-fast/types';
import {Dispatch} from '@ngxs-labs/dispatch-decorator';
import {
  ChangeSelectedItem,
  Deposit,
  DepositSelected,
  P2pDepositState,
  PauseDepositing,
  RemoveDepositItem,
  RemoveMarketItems,
  ReqAppointing,
  ResetSelected,
  ResumeDepositing,
  SellNow,
  StopDepositing,
  ToggleDepositItem,
} from '../states';
import {Actions, Select, Store} from '@ngxs/store';
import {OpenModal} from '@csgofast/core/state/modals';

@Injectable()
export class P2pDepositService {
  @Select(P2pDepositState.selected)
  public selected$!: Observable<IP2pDepositItem[]>;

  @Select(P2pDepositState.selectedSum)
  public selectedSum$!: Observable<number>;

  @Select(P2pDepositState.depositingItems)
  public depositing$!: Observable<IP2pDepositingItem[]>;

  @Select(P2pDepositState.isItemsOnPause)
  public isItemsOnPause$!: Observable<boolean>;

  // public depositModifier$ = this.actions$.pipe(
  //   ofActionSuccessful(GetDepositModifierSuccess),
  //   map((action: GetDepositModifierSuccess) => action.payload)
  // );

  constructor(private readonly _store: Store, private readonly actions$: Actions) {}

  // public getDepositById(id: number): Observable<IP2pDepositItem> {
  //   return this._store.select(P2pDepositState.depositById).pipe(
  //     map((filterFn) => filterFn(id)),
  //     filter((el): el is IP2pDepositItem => !!el)
  //   );
  // }
  public getDepositById(id: number): IP2pDepositItem | undefined {
    return this._store.selectSnapshot(P2pDepositState.selected).find((s) => s.steamInventoryId === id);
  }

  public requestConfirm(id: number): void {
    this.reqAppointing(id, MarketAction.Confirm);
  }

  public requestDecline(id: number): void {
    this.reqAppointing(id, MarketAction.Decline);
  }

  @Dispatch() public removeDepositItem = (payload: IP2pDepositItem) => new RemoveDepositItem(payload);
  @Dispatch() public toggleDepositItem = (payload: IP2pDepositItem) => new ToggleDepositItem(payload);
  @Dispatch() public depositSelected = () => new DepositSelected();
  @Dispatch() public resetSelected = () => new ResetSelected();
  @Dispatch() public reqAppointing = (id: number, action: MarketAction) => new ReqAppointing(id, action);
  @Dispatch() public sellNow = (id: number) => new SellNow(id);
  @Dispatch() public deleted = (ids: number[]) => new RemoveMarketItems(ids);
  @Dispatch() public stop = () => new StopDepositing();
  @Dispatch() public pause = (id?: number) => new PauseDepositing(id);
  @Dispatch() public resume = (id?: number) => new ResumeDepositing(id);
  @Dispatch() public deposit = (id: number, price: number) => new Deposit(id, price);
  @Dispatch() public setDepositById = (item: IP2pDepositItem) => new ChangeSelectedItem(item);
  @Dispatch() public showAuctionCompletedModal = (item: Observable<IP2pDepositingItem>) =>
    new OpenModal(ModalNames.P2P_AUCTION_COMPLETED, item);
  // @Dispatch() public getDepositModifier = () => new GetDepositModifier();
}
